module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "indent5"
  }, [_c('span', {
    attrs: {
      "aria-label": "page 31",
      "id": "page_31",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("Hailey stood next to Eva. “I’m sorry.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Eva kept her gaze on the horizon. “There are warbots in the forest right now. I can "), _c('i', [_vm._v("feel")]), _vm._v(" the fear they’re causing the plants and animals. These warbots are searching for something.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Though the facts were bleak, Eva somehow felt better sharing everything she knew with Hailey. It was as if a heavy burden had been lifted from her spirit.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Hailey put his arm around Eva. “Well, then, that’s all the more reason for us to leave. Loroc can’t find you if you’re not here.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The mention of Loroc’s name brought forth his parting words to Eva: "), _c('i', [_vm._v("I do not fall by your hand. You, however, shall fall by mine.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He’ll find me.” Eva turned back toward the wandering tree. “It’s just a matter of time.” She hoisted herself up onto a branch and offered a hand to help Hailey. Both climbed up to the topmost bough, and the tree began moving.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As the wind tousled her hair, Eva watched the forest give way to a flat barren plain. Somewhere in the distance lay the wreckage of the "), _c('i', [_vm._v("Bijou")]), _vm._v(".")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fa354302","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781481403887/xhtml/ch03_sub02.vue
// module id = 105
// module chunks = 0